import {
  APPLICATION_STATE_WARNINGS,
  DEV_TOOLS_PERFORMANCE_STORAGE_KEY,
} from './performance.constants';

export const isApplicationStateWarningsEnabled = () =>
  (localStorage.getItem(DEV_TOOLS_PERFORMANCE_STORAGE_KEY) || '')
    .split(',')
    .includes(APPLICATION_STATE_WARNINGS);
